import React, { Component } from 'react';
import PropTypes from 'prop-types';

import messageBoxConstants from '../constants/message-box-constatns';

import '../styles/message-box.css';

class MessageBox extends Component {
  renderGlyphicon(type) {
    switch (type) {
      case messageBoxConstants.message_types.error:
        return <span className="glyphicon glyphicon-remove-sign" />;
      case messageBoxConstants.message_types.warning:
        return <span className="glyphicon glyphicon-warning-sign" />;
      default:
        return <span className="glyphicon glyphicon-info-sign" />;
    }
  }

  render() {
    const { message, type, customClass, translationObject } = this.props;
    const { t } = this.context;

    if (message) {
      return (
        <div className={`alert-message-container alert-message-${type} ${customClass ? customClass : ''}`}>
          {this.renderGlyphicon(type)}
          <span className="alert-message-container__text">{t(message, translationObject || {})}</span>
        </div>
      );
    } else return null;
  }
}

MessageBox.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default MessageBox;



// WEBPACK FOOTER //
// ./src/app/shared/error-message/components/message-box.js